import CoreBase from '../../../../services/engines/CoreBase';
import logService from '../../../../services/wss/logService3';
import groupNodeCache from '../Engines/GroupNodeCache';

const _name = 'OnEntriesAddedHandler';

/**
 * Handles the OnEntriesAdded SignalR event (renamed from OnTopicEntriesAdded).
 * Adds new entries to the correct node in cache.
 * Expects pre-filtered data — engine filters by active group before calling.
 * Only dependency is GroupNodeCache — fully testable in isolation.
 */
export default class OnEntriesAddedHandler extends CoreBase {
    handle = (data) => {
        try {
            if (!data?.length) return false;
            data.forEach((cmd) => {
                if (!cmd.node || !cmd.entry) return;
                groupNodeCache.addOrUpdate(cmd.node, cmd.entry);
            });
            return true;
        } catch (error) {
            logService.logError(`${_name}.handle: ${error.message}`);
            return false;
        }
    };
}
